import { ReactElement } from 'react';
import { Field } from '@ardoq/forms';
import {
  SidebarMenuSection,
  SidebarMenuSectionProps,
} from './SidebarMenuSection';

type SidebarMenuFormSectionProps = Omit<SidebarMenuSectionProps, 'children'> & {
  children?: ReactElement<any>[] | ReactElement<any>;
};

export const SidebarMenuFormSection = ({
  children,
  ...sidebarEditorSectionProps
}: SidebarMenuFormSectionProps) => (
  <SidebarMenuSection {...sidebarEditorSectionProps}>
    {[children]
      .flat()
      .filter(child => Boolean(child))
      .map((child, index) => (
        <Field key={index}>{child}</Field>
      ))}
  </SidebarMenuSection>
);
